module.exports = __webpack_public_path__ + "img/Frame 158.59b94e89.svg";